import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const SET_LIBRARY_STAFF_SERVICEABLE = gql`
  mutation SetLibraryStaffServiceable(
    $where: LibraryStaffUniqueInput!
    $data: SetLibraryStaffServiceableInput!
  ) {
    setLibraryStaffServiceable(where: $where, data: $data) {
      message
    }
  }
`;
